import { render, staticRenderFns } from "./AnnotationImageCard.vue?vue&type=template&id=7226bf12&scoped=true&"
import script from "./AnnotationImageCard.vue?vue&type=script&lang=js&"
export * from "./AnnotationImageCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationImageCard.vue?vue&type=style&index=0&id=7226bf12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7226bf12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VImg,VRow,VTab,VTabs,VTextField})
